import { TableHeaderProps } from '@components/table/types'
import { Helper } from '@utils/index'
import styled from '@emotion/styled'
import Status from '@components/status'

export const columns: TableHeaderProps[] = [
  {
    title: 'Match ID',
    key: 'matchId',
  },
  {
    title: 'Created By',
    key: 'createdBy',
    render: (item) => {
      // Function to get initials from name
      const getInitials = (name) => {
        if (!name) return 'U' // Default to 'U' for Unknown

        const nameParts = name.split(' ')
        if (nameParts.length === 1) {
          return nameParts[0].charAt(0).toUpperCase()
        }
        return (
          nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)
        ).toUpperCase()
      }

      // Function to generate a consistent color based on the name
      const getAvatarColor = (name) => {
        if (!name) return '#007bff' // Default blue for unknown

        const colors = [
          '#007bff',
          '#28a745',
          '#dc3545',
          '#ffc107',
          '#17a2b8',
          '#6f42c1',
          '#e83e8c',
          '#fd7e14',
          '#20c997',
          '#6610f2',
        ]

        let hash = 0
        for (let i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash)
        }

        return colors[Math.abs(hash) % colors.length]
      }

      const hasAvatar = item?.user?.avatar
      const userName = item?.createdBy?.name || 'Unknown'
      const isAdmin = userName.toLowerCase() === 'admin'
      const initials = getInitials(userName)
      const avatarColor = getAvatarColor(userName)

      return (
        <CreatedByWrapper>
          <ProfilePreview
            style={{
              backgroundColor: isAdmin
                ? '#6c757d'
                : hasAvatar
                  ? 'transparent'
                  : avatarColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            {hasAvatar ? (
              <img
                src={`https://admin.tournaop.com/${item.user.avatar}`}
                alt="user avatar"
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
            ) : null}

            <div
              className="initials-fallback"
              style={{
                display: hasAvatar ? 'none' : 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                fontSize: '16px',
              }}
            >
              {isAdmin ? 'A' : initials}
            </div>
          </ProfilePreview>
          <UserDetails>
            <Name>{userName}</Name>
          </UserDetails>
        </CreatedByWrapper>
      )
    },
  },
  {
    title: 'Matchroom Name',
    key: 'matchRoomName',
    render: (item) => <span>{item.matchRoomName}</span>,
  },
  {
    title: 'Game Name',
    key: 'gameName',
    render: (item) => <span>{item.gameName}</span>,
  },
  {
    title: 'Match Type',
    key: 'matchType',
    render: (item) => <span>{item.matchType}</span>,
  },
  {
    title: 'Match Time',
    key: 'matchTime',
    render: (item) => (
      <MatchDateTimeWrapper>
        <p>{item.matchTime.date}</p>
        <p>{item.matchTime.time}</p>
      </MatchDateTimeWrapper>
    ),
  },
  {
    title: 'Status',
    key: 'status',
    render: (item) => {
      return <Status item={item} />
    },
  },
]

const CreatedByWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
`

const ProfilePreview = styled.div`
  width: 50px;
  height: 50px;
  background-color: #9395e9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 2px;
`
const Name = styled.p`
  color: ${(props: any) => props.theme.colors.text};
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
`
const Number = styled.p`
  color: ${(props: any) => props.theme.colors.text50};
  letter-spacing: 0.25px;
  line-height: 20px;
`

const MatchDateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  line-height: 1.4;
`
